import React, { use, useEffect, useReducer, useState } from 'react';
import TextInput from '../Common/TextInput';
import { useAccounts } from '../../DataStore/AccountsContext';
import ActivityLoader from '../Common/ActivityLoader';
import Notification from '../Common/Notification';
import ajaxSchool from '../../util/remote/ajaxSchool';
import { useSchool } from '../../DataStore/SchoolContext';
import CallOut from '../Common/CallOut';
import { useTheme } from '../../DataStore/ThemeContext';

const reducer = (state, action)=>{
    if(action.type === "RESET"){
        return {...initialState}
    }
    return { ...state, [action.type]: action.value };
}

const initialState = {
    voteName: '',
    cashAccount: '',
    incomeAccount: '',
    loading: false,
}


const EditFeesVote = ({feesVote}) => {

    const [state, dispatch] = useReducer(reducer, initialState);
    const [info, setInfo] = useState('');
    const {setSystemFunction} = useTheme();
     const {
            getIncomeAccounts,
            accountsReceivableListing,
            incomeAccountListing,
            getAccountsReceivable,
        } = useAccounts();

    const {getFeesVotes} = useSchool();

    useEffect(()=>{
        getIncomeAccounts();
        getAccountsReceivable();
    }, [])

    useEffect(()=>{
        if(feesVote){
            dispatch({type: 'voteName', value: feesVote.vote_name})
            dispatch({type: 'cashAccount', value: {label: feesVote.asset_account.account_name, value: feesVote.asset_account.account_id}})
            dispatch({type: 'incomeAccount', value: {label: feesVote.collection_account.account_name, value: feesVote.collection_account.account_id}})
        }
    }, [feesVote])

    useEffect(()=>{
        setSystemFunction(() => handleSave);
        return ()=> setSystemFunction(() => {});
    }, [state])


    const handleSave=async()=>{
        setInfo('');
        if(state.voteName.length > 0 && state.cashAccount.value && state.incomeAccount.value)
        {   
            setInfo(<ActivityLoader/>)
            dispatch({type: 'loading', value: true})
            const server_response = await ajaxSchool.updateFeesVote(feesVote.id, state.voteName, state.incomeAccount.value, state.cashAccount.value);
            dispatch({type: 'loading', value: false})
            if(server_response.status==="OK"){
                setInfo(<Notification type="success" message={server_response.message} closable={false}/>)
                getFeesVotes(true)
            }else{
                setInfo(<Notification type="danger" message={server_response.message} closable={false}/>)
            }

        }else{
            setInfo(<Notification type="danger" message="Complete all vote fields and try again." closable={false}/>)
        }
    }



    const RenderIncomeAccount = () => {

        const options=[];
        if(Array.isArray(incomeAccountListing))
        {
            incomeAccountListing.map((item, key)=>
                options.push({label:item.account_number + ' ' + item.account_name, value:item.account_id})
            )
        }

        return(
            <TextInput
                type="select"
                label="Income Category"
                placeholder={"Select income account..."}
                leftIcon="fa fa-university"
                options={options}
                onChange={item => dispatch({type: 'incomeAccount', value: item})}
                leftComponent={<i className="fa fa-university link" onClick={()=>getIncomeAccounts(true)}></i>}
                loading={!incomeAccountListing}
                required
                wrap
                value={state.incomeAccount}
            />
        )
    };

    const RenderCashAccount = () => {

        const options=[];
        if(Array.isArray(accountsReceivableListing))
        {
            accountsReceivableListing.map((item, key)=>
                options.push({label:item.account_number + ' ' + item.account_name, value:item.account_id})
            )
        }

        return(
            <TextInput
                type="select"
                label="Accounts Receivable"
                placeholder={"Select Accounts Receivable..."}
                leftIcon="fa fa-university"
                options={options}
                onChange={item => dispatch({type: 'cashAccount', value: item})}
                leftComponent={<i className="fa fa-university link" onClick={()=>getAccountsReceivable(true)}></i>}
                loading={!accountsReceivableListing}
                required
                wrap
                value={state.cashAccount}
            />
        )
    };


    return (
        <>
        <CallOut
            title="Fees Votes"
            description="A fees vote represents a specific charge such as tuition, meals, transport, or activities. Votes are used to structure billing and track payments accurately."
            />
        <div className='mt-4'>{info}</div>
        <form method='post' onSubmit={handleSave}>
                <TextInput
                    type="text"
                    label="Vote Name"
                    placeholder="Enter Vote Name"
                    leftIcon="fa fa-tag"
                    onChange={e => dispatch({type: 'voteName', value: e.target.value})}
                    required
                    value={state.voteName}
                    wrap
                    />
        
                 {RenderIncomeAccount()}
                 {RenderCashAccount()}


        </form>
        </>
    );
};

export default EditFeesVote;